import React from 'react'
import config from 'src/core/config'
import Layout from './main'

export default class extends React.Component {
  render() {
    const { pathname } = this.props.location
    return (config.route.whiteList.indexOf(pathname) > -1) ? (<div>{this.props.children}</div>) : (<Layout>{this.props.children}</Layout>)
  }
}



// WEBPACK FOOTER //
// ./layout/index.js